module.exports = __webpack_public_path__ + "static/media/four.11a9a2a0.svg";